export const youtubeVideoIdSeparator = ' ';
